<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-25 md-small-size-100">
      <md-field>
        <label>{{ $t("communication.student_grade") }}</label>
        <md-select
          name="target"
          v-model="data.selectedList"
          id="target"
          multiple
        >
          <md-option
            :value="grade.name"
            v-for="(grade, gradeIndex) in gradeList"
            :key="gradeIndex"
            >{{ grade.name }}</md-option
          >
        </md-select>
      </md-field>
    </div>
  </div>
</template>
<script>
import { service_names } from "@/constants/Services";

export default {
  name: "family-option",
  components: {},
  props: ["data"],
  data() {
    return {
      gradeList: [],
      query: {
        page: 0,
        limit: 100
      }
    };
  },
  mounted() {
    this.data.filter_by = "Grade";
    this.getGrades();
  },
  methods: {
    getGrades() {
      this.$axios
        .get(`${service_names.school}/grades`, this.query)
        .then(response => {
          this.gradeList = response.data.data;
        });
    }
  }
};
</script>
